// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export function getActiveUserCount(
  hostname: string,
  plan: number
): Promise<number> {
  return mushodoPromise<number>('GetActiveUsersFromThisMonthUntilNow', {
    hostname,
    plan,
  });
}
